import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["groupButton", "scroll"]

  selectGroup(event) {
    const selected = event.currentTarget.dataset.group
    this.groupButtonTargets.forEach(button => {
      const active = button.dataset.group === selected
      button.setAttribute("aria-pressed", String(active))
      button.classList.toggle("btn-primary", active)
      button.classList.toggle("btn-outline-secondary", !active)
    })
    this.element.querySelectorAll("[data-metric-group]").forEach(cell => {
      cell.hidden = selected !== "all" && cell.dataset.metricGroup !== selected
    })
    if (this.hasScrollTarget) this.scrollTarget.scrollLeft = 0
  }
}
